import action from "../helpers/rest-client";
import { AnswerDto } from "../types/answer.dto";
import { GetOneQuizOutDto, NewAnswerQuizOutDto } from "../types/quiz.dto";

export class ErrorQuiz extends Error {}
//localhost:3000/api/adeccoLab/course/quiz/3
class Quiz {
  public getOne(payload: GetOneQuizOutDto) {
    const { idQuiz } = payload;
    return action
      .Get({
        url: `/course/quiz/${idQuiz}`,
      })
      .then((response) => {
        return { response: response.success.result };
      })
      .catch((error) => {
        return { error };
      });
  }

  public newAnswerQuiz(body: NewAnswerQuizOutDto) {
    return action
      .Post({
        url: `/enrollment/quiz/answer`,
        body,
      })
      .then((response) => {
        return { response: response.success.result };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const quiz = new Quiz();
export default quiz;
